module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei3.svg";